import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface ExamChildCategory {
  id: number,
  name: string,
  order: number,
  icon?: string,
}

export interface ExamCategory {
  id: number,
  name: string,
  description?: string,
  order: number,
  icon?: string,
  exam_count?: number,
  parent_id?: number | null,
  ParentCategory?: {
    id: number,
    name: string,
  } | null,
  ChildCategories?: ExamChildCategory[],
}

export interface Exam{
  id: number,
  name: string,
  time: number,
  note: string,
  create_date: string,
  type: string,
  order: string,
  status: string,
  is_free: boolean,
  cat_id?: number | null,
  ExamCategory?: ExamCategory | null,
  user_exam_status?: 'NOT_STARTED' | 'IN_PROGRESS' | 'DONE' | 'NOT_STARTEDOT_STARTED',
}

export interface ExamRequest{
  id?: number,
  name: string,
  time: number,
  note: string,
  type: string,
  status: string
}

export interface Question{
  id?: string,
  question: string,
  question_extra: string,
  question_blue: string,
  answer_left_text?: string,
  answer_right_text?: string,
  answers: {
    R1: {
      A: string,
      B: string,
      C: string,
      D: string,
      E: string,
      F: string,
    },
    R2: {
      A: string,
      B: string,
      C: string,
      D: string,
      E: string,
      F: string,
    },
    R3: {
      A: string,
      B: string,
      C: string,
      D: string,
      E: string,
      F: string,
    }
  },
  answersheet: string,
  answersheet_explain?: string,
  section: string,
  type: string,
  UserAnswer: {
    answer: string
  },
  pined: boolean,
}

export interface QuestionRequest{
  id?: string,
  question: string,
  question_extra?: string,
  question_blue?: string,
  answers: any,
  answersheet: string,
  answersheet_explain?: string,
  section: string,
  type: string,
}

export interface QuestionByExam{
  exam: Exam,
  question: Question[]
}

export const examApi = createApi({
  reducerPath: 'examApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['exam','question','examCategory'],

  endpoints: (builder) => ({
    getAllExams: builder.query<Exam[],void>({
      query: () => 'exam/all-exams',
      providesTags: ['exam']
    }),

    searchExams: builder.query<Exam[], string>({
      query: (q) => ({
        url: 'exam/search',
        params: { q },
      }),
      providesTags: ['exam'],
    }),

    getAllExamCategories: builder.query<ExamCategory[], void>({
      query: () => 'exam/category/all',
      providesTags: ['examCategory']
    }),

    getQuestion: builder.query<Question,any>({
      query: ({examId,qstId,userExam}) => `exam/question/qByexam/${examId}/${qstId}/${userExam}`,
      providesTags: ['question']
    }),
  }),
})

export const { useGetAllExamsQuery , useGetQuestionQuery, useGetAllExamCategoriesQuery, useSearchExamsQuery } = examApi
